export default __webpack_public_path__ + "122171ded59b5b5ab5c6e1a18736e5cb.png";